import Modal from "components/atom/Modal.tsx";
import { useAppSelector } from "config/store";
import Button from "components/atom/button/Button.tsx";
import designerPng from "assets/images/designer.png";
import { UserType } from "globals/types/models.ts";
import { USER_PLAN_TYPES } from "globals/constants.ts";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";

function ConfirmEventPublishModal(props: { isOpen: boolean, onClose: () => void, onAccept: () => void }) {
  const { onClose, onAccept, isOpen } = props;
  const currentUser: UserType | null = useAppSelector(state => state.auth.user);
  //const totalEventCountCreated: number = useAppSelector(state => state.auth.totalEventCountCreated)
  const { t } = useTranslation();


  if (!isOpen) {
    return null;
  }


  return (
    <Modal flexibleHeight className="-action-blocked" onClose={onClose}>
      <div className="w-full">
        <img src={designerPng} className="mx-auto block h-[200px] w-auto" />
        <h2 className="text-2xl pb-3 text-center font-semibold">
          {t("popup.confirmEventPublish.title")}
        </h2>
        <p className="pb-12 text-center text-gray-400">

          <Fragment>
            {currentUser?.planType === USER_PLAN_TYPES.TRIAL && (
              <span>
                {t("popup.confirmEventPublish.descriptionTrial")}
              </span>
            )}
            {currentUser?.planType !== USER_PLAN_TYPES.TRIAL && (
              <span>
                {t("popup.confirmEventPublish.descriptionOther")}
              </span>
            )}
          </Fragment>

        </p>
        <Button className="block w-full" onClick={onAccept}>
          {t("continue")}
        </Button>
      </div>
    </Modal>
  );
}


export default ConfirmEventPublishModal;
